// extracted by mini-css-extract-plugin
module.exports = {"ios":"variables_ios__1fFAp","md":"variables_md__17az1","title-large":"variables_title-large__nlpV5"};